module.exports = __webpack_public_path__ + "img/05_Pa.8ef124bb.jpg";